export const constants = {
    SCENES: {
        CANNONGAME: "CANNONGAME", 
        PRIMARY: "PRIMARY"
    }
}